import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  CircularProgress,
  Alert,
  Paper
} from '@mui/material';
import vendorApi from '../services/vendorApi';

const VendorSales = () => {
  const navigate = useNavigate();
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadSales();
  }, []);

  const loadSales = async () => {
    try {
      const data = await vendorApi.getSales();
      setSales(data);
    } catch (err) {
      setError('Failed to load sales');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      draft: 'default',
      scheduled: 'info',
      published: 'primary',
      in_progress: 'warning',
      completed: 'success',
      cancelled: 'error'
    };
    return colors[status] || 'default';
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        My Estate Sales
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom sx={{ mb: 3 }}>
        View all your estate sales and track their progress
      </Typography>

      <Card>
        <CardContent>
          {sales.length > 0 ? (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Sale Name</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Start Date</TableCell>
                    <TableCell>Location</TableCell>
                    <TableCell align="right">Items</TableCell>
                    <TableCell align="right">Est. Value</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sales.map((sale) => (
                    <TableRow
                      key={sale.id}
                      hover
                      onClick={() => navigate(`/vendor/sales/${sale.id}`)}
                      sx={{ cursor: 'pointer' }}
                    >
                      <TableCell>
                        <Typography variant="body2" fontWeight="medium">
                          {sale.name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={sale.status}
                          color={getStatusColor(sale.status)}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        {sale.start_date || 'Not scheduled'}
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" noWrap>
                          {sale.city}, {sale.state}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">{sale.item_count || 0}</TableCell>
                      <TableCell align="right">
                        ${sale.estimated_value?.toLocaleString() || '0'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography variant="body2" color="text.secondary" align="center" sx={{ py: 4 }}>
              No sales found
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default VendorSales;
